import {loop, Effects} from 'redux-loop';
import { FETCH_SEARCH_FEED_LIST, fetchSearchFeedList } from './actions';
import {reducer as feedReducer} from 'modules/feed';

export const initialState = {
  feed: {},
};

export default (state = initialState, action) => {
  if (action.type === FETCH_SEARCH_FEED_LIST) {
    const [ feedModel, feedEffect ] = feedReducer(state.feed, action.action);
    return loop({
      feed: feedModel
    },
      Effects.lift(feedEffect, fetchSearchFeedList)
    )
  }
  return loop(state, Effects.none())
}



/** WEBPACK FOOTER **
 ** ./src/app/modules/search/reducer.js
 **/